import { render } from "./blog-life-style-images.vue?vue&type=template&id=0f378ce1&scoped=true"
import script from "./blog-life-style-images.vue?vue&type=script&lang=js"
export * from "./blog-life-style-images.vue?vue&type=script&lang=js"

import "./blog-life-style-images.vue?vue&type=style&index=0&id=0f378ce1&scoped=true&lang=css"

import exportComponent from "/Users/suniyl/Documents/work/shopify-projects/behno/behno-us-version-3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f378ce1"]])

export default __exports__